import { useQuery } from '@apollo/client'
import {
    CandidateFilterCategory,
    SearchIndexField,
} from '__generated__/graphql'
import { FilterWrapper } from 'recruiter/components/FilterWrapper'
import { useRosterSearchFilter } from 'recruiter/hooks'
import { GetRecruitersByUserIds } from 'shared/components/RecruitersAutocomplete/RecruitersAutocomplete.gql'
import RecruitersAutocompleteMultiple from 'shared/components/RecruitersAutocomplete/RecruitersAutocompleteMultiple'
import { RecruitersAutocompleteProps } from 'shared/components/RecruitersAutocomplete/RecruitersAutocompleteProps'
import { getFullName } from 'shared/utils'

export function RosterCreatedByFilter() {
    const { value, setValue } = useRosterSearchFilter(
        SearchIndexField.RosterCreatedBy
    )

    const creatorIds = value?.value?.stringArray ?? []

    const { data, loading } = useQuery(GetRecruitersByUserIds, {
        variables: { ids: creatorIds },
    })

    const handleCreatorChange: RecruitersAutocompleteProps<true>['onChange'] = (
        e,
        newValues
    ) => {
        if (newValues.length === 0) {
            setValue(null)
            return
        }

        setValue({
            category: CandidateFilterCategory.All,
            value: { stringArray: newValues.map(({ userId }) => userId) },
        })
    }

    return (
        <FilterWrapper label="Created By">
            <RecruitersAutocompleteMultiple
                ChipProps={{ size: 'small' }}
                onChange={handleCreatorChange}
                getOptionLabel={({ user }) => getFullName(user ?? {})}
                placeholder="Search recruiters..."
                value={data?.recruitersByUserId || []}
                loading={loading}
            />
        </FilterWrapper>
    )
}
